import angular from 'angular';

export const templatesModule = angular.module(
  'portainer.docker.react.components.templates',
  []
).name;
